/**
 * Technology Table Configuration
 *
 * Column widths migrated to central registry (Day 4 - 2025-10-19)
 * Location: src/config/columns/columnRegistry.ts
 *
 * Constants extracted to constants/ directory (Phase 1 - 2025-10-22)
 * Location: src/sections/technology/constants/
 *
 * Table-specific configuration and helper functions.
 *
 * Pattern matches:
 * - src/sections/asset/config/columns.ts
 * - src/sections/seeds/config/columns.ts
 */

import {
  REQUIRED_COLUMN_ID,
  SORTABLE_COLUMNS,
  TECHNOLOGY_DEFAULT_COLUMN_ORDER,
} from '@/sections/technology/constants';
import { generateStorageKey } from '@/utils/tableConfig.util';

// Re-export constants for backward compatibility
export {
  REQUIRED_COLUMN_ID,
  SORTABLE_COLUMNS,
  TECHNOLOGY_DEFAULT_COLUMN_ORDER,
};

// ============================================================================
// TABLE CONFIGURATION
// ============================================================================

/**
 * Storage key for persisting column configuration
 * v1: Initial centralized column configuration
 */
export const TECHNOLOGY_TABLE_STORAGE_KEY = generateStorageKey(
  'technologies',
  undefined,
  2
);

// ============================================================================
// HELPER FUNCTIONS
// ============================================================================

/**
 * Check if a column supports sorting
 *
 * @param columnId - The column identifier to check
 * @returns True if the column is in the sortable columns list
 *
 * @example
 * ```typescript
 * isColumnSortable('vendor'); // true
 * isColumnSortable('tags');   // false
 * ```
 */
export const isColumnSortable = (columnId: string): boolean => {
  return SORTABLE_COLUMNS.includes(
    columnId as (typeof SORTABLE_COLUMNS)[number]
  );
};
